// Environment configuration for Vite
export const config = {
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:3003/api',
  IS_DEV: import.meta.env.MODE === 'development',
  IS_PROD: import.meta.env.MODE === 'production',
} as const;
